export enum ApiRequestStatusEnum {
  NONE,
  SUCCESS,
  PENDING,
  ERROR,
}
